"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageSpinnerSlice = pageSpinnerSlice;
const pageSpinnerInitialState = {
    pageSpinner: {
        isLoading: false,
    },
};
function pageSpinnerSlice(set) {
    return {
        ...pageSpinnerInitialState,
        setPageLoading(isLoading) {
            set((state) => {
                state.pageSpinner.isLoading = isLoading;
                return state;
            }, false, '[setPageLoading]');
        },
    };
}
